import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import './carousel-article-small.component.scss';
var CarouselArticleSmall = /** @class */ (function (_super) {
    tslib_1.__extends(CarouselArticleSmall, _super);
    function CarouselArticleSmall(element) {
        return _super.call(this, element) || this;
    }
    CarouselArticleSmall.prototype.init = function () {
        this.sliderItems = Number(this.element.getAttribute('data-items'));
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.windowWidth = document.documentElement.clientWidth;
        switch (this.sliderItems) {
            case 1:
                this.breakpoints = {};
                break;
            case 2:
                this.breakpoints = {
                    576: {
                        initialSlide: 0,
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    }
                };
                break;
            default:
                this.breakpoints = {
                    1200: {
                        initialSlide: 0,
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                    768: {
                        initialSlide: 0,
                        slidesPerView: 2.1,
                        spaceBetween: 10,
                    },
                    576: {
                        initialSlide: 0,
                        slidesPerView: 1.1,
                        spaceBetween: 10,
                    }
                };
                break;
        }
        this.sliderConfig = {
            slidesPerView: this.sliderItems,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: this.breakpoints,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    CarouselArticleSmall.prototype.bindEvents = function () { };
    return CarouselArticleSmall;
}(Base));
export { CarouselArticleSmall };



//////////////////
// WEBPACK FOOTER
// ./components/carousel-article-small/carousel-article-small.component.ts
// module id = 188
// module chunks = 0